import React, { useReducer } from 'react';
import AppRouter from './Navigation/AppRouter';
import Reducer from './reducer/Reducer';
import { AppContext, DispatchContext } from './AppContext';
import { initialState } from './reducer/InitialState';
import { strings } from './locate';


export default function App(props) {
  const [state, dispatch] = useReducer(Reducer, { ...initialState, strings });
  strings.setLanguage(state.lang);

  return (
    <AppContext.Provider value={state}>
      <DispatchContext.Provider value={dispatch}>
          <AppRouter />
      </DispatchContext.Provider>
    </AppContext.Provider>
  );
}